<template>
    <div class="popup-friend-mask">
        <div class="popup-friend">
            <div class="popup-friend-my-name">
                <div class="dragon-profile">
                    <img :src="userdragonavatar" alt="" />
                </div>
                <p
                    v-html="$t('base.friendTitle', { name: userdragonname })"
                ></p>
            </div>
            <div class="popup-friend-list">
                <div class="popup-friend-list-head">
                    <span>{{ $t('popup.friend.name') }}</span>
                    <span>{{ $t('popup.friend.battles') }}</span>
                    <span>{{ $t('popup.friend.power') }}</span>
                    <span v-html="$t('popup.friend.battleAgain')"></span>
                </div>
                <div class="popup-friend-list-body" ref="scroll">
                    <p
                        class="empty_tips"
                        v-if="showEmpty"
                        v-html="$t('base.friendEmptyTips')"
                        @click="clickInviteFrientTips"
                    ></p>
                    <ul class="popup-friend-list-content" v-else>
                        <li
                            v-for="(item, index) of friendBattleList"
                            :key="index"
                        >
                            <span
                                @click="
                                    replayBattle(item.id, item.user_id_object)
                                "
                                >{{ item.user_name_object }}</span
                            >
                            <span
                                >Victory {{ item.num_win }}<br />Defeat
                                {{ item.num_lose }}</span
                            >
                            <span>{{ item.get_score }}</span>
                            <span @click="battleAgain(item)"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import Pullup from '@better-scroll/pull-up';
import { mapMutations, mapActions } from 'vuex';
import { Bus } from '@/utils/eventBus.js';
import i18n from '@/lang/index';

BScroll.use(Pullup);

export default {
    name: 'popup-friend',
    data() {
        return {
            isPullUpLoad: false,
            bscroll: null,
            friendBattleList: [],
            page: 1,
            size: 6,
            showEmpty: false // 是否显示空白提示
        };
    },
    computed: {
        username() {
            return (
                this.$store.state.userinfo &&
                this.$store.state.userinfo.user_name
            );
        },
        userdragonname() {
            return (
                this.$store.state.userinfo &&
                this.$store.state.userinfo.dragon_name
            );
        },
        userdragonavatar() {
            return (
                this.$store.state.userinfo &&
                require('../../assets/img/game/dragonAvatar/' +
                    this.$store.state.userinfo.dragon_ename +
                    '.png')
            );
        },
        userdragonename() {
            return (
                this.$store.state.userinfo &&
                this.$store.state.userinfo.dragon_ename
            );
        }
    },
    methods: {
        ...mapMutations([
            'SET_STATE',
            'SHOW_POPUP',
            'HIDE_POPUP',
            'SET_GAME_STATE',
            'PLAY_SOUND',
            'STOP_SOUND'
        ]),
        ...mapActions(['getBattleFriList', 'getBattleHistoryList', 'showComm']),
        initBscroll() {
            this.bscroll = new BScroll(this.$refs.scroll, {
                pullUpLoad: true,
                click: true,
                bounce: {
                    top: true,
                    left: false,
                    right: false,
                    bottom: false
                }
            });
            this.bscroll.on('pullingUp', this.pullingUpHandler);
        },
        async pullingUpHandler() {
            this.isPullUpLoad = true;
            this.page++;
            await this.getFriList(this.page);
            this.bscroll.finishPullUp();
            // this.bscroll.refresh();
            this.isPullUpLoad = false;
        },
        async getFriList(page) {
            const friBattleListRes = await this.getBattleFriList({
                page: this.page,
                size: this.size
            });
            if (friBattleListRes.code == 1) {
                this.friendBattleList = [
                    ...this.friendBattleList,
                    ...friBattleListRes.data
                ];
                this.showEmpty = this.friendBattleList.length == 0;
                this.bscroll.refresh();
            } else {
                console.log(friBattleListRes.msg);
            }
        },
        // 战斗回放  logId - 记录id  friendId - 朋友id
        async replayBattle(logId, friendId) {
            this.PLAY_SOUND('button');
            // console.log('战斗回放');
            // 我的用户id
            let _myUserid = this.$store.state.userinfo.id;
            const getBattleHistoryListRes = await this.getBattleHistoryList({
                user_id: this.$store.state.userinfo.id,
                object_id: friendId,
                sort: 1, //倒序
                page: 1,
                size: 1
            });
            console.log(getBattleHistoryListRes);
            if (
                getBattleHistoryListRes.code == 1 &&
                getBattleHistoryListRes.data.length > 0
            ) {
                let _replayData = getBattleHistoryListRes.data[0];
                let _pkWordsData = {
                    ids: _replayData.content_id.join(','),
                    words: gameAni.content2pkWords(_replayData.content)
                };
                let _player2Data = gameAni.handlePkData(_replayData, _myUserid);
                this.HIDE_POPUP('friend');
                Bus.$emit('_replayPk', _player2Data.player2, _pkWordsData);
            } else {
                alert(getBattleHistoryListRes.msg);
            }
        },
        // 再次战斗 friendId - 朋友id
        battleAgain(friendData) {
            this.PLAY_SOUND('button');
            this.$LOG.send_click_battlewithfriends();
            // console.log('再次战斗');
            if (friendData.num_win + friendData.num_lose >= 3) {
                // alert(i18n.t('msg.pklimit'));
                this.showComm({
                    text: i18n.t('msg.pklimit'),
                    size: 'mid'
                });
                return;
            }
            this.HIDE_POPUP('friend');
            Bus.$emit('_startPk', {
                id: friendData.dragon_ename_object,
                name: friendData.user_name_object,
                user_id: friendData.user_id_object
            });
        },
        // 无好友时，点击提示文案拉起分享弹层
        clickInviteFrientTips() {
            this.SHOW_POPUP('share');
        }
    },
    async mounted() {
        this.initBscroll();
        await this.getFriList(1);
    }
};
</script>

<style lang="less" scoped>
.popup-friend-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 28px;
    display: flex;

    .popup-friend {
        width: 551px;
        height: 727px;
        background: url(~@/assets/img/pop_fri_frame.png) center/100% 100%
            no-repeat;
        margin: auto;
        padding-top: 77px;
        box-sizing: border-box;

        &-my-name {
            width: 462px;
            height: 102px;
            background: url(~@/assets/img/pop_fri_myname_bg.png) center/100%
                100% no-repeat;
            margin: 0 auto;
            display: flex;
            align-items: center;
            padding-left: 144px;
            box-sizing: border-box;
            position: relative;

            .dragon-profile {
                width: 130px;
                height: 130px;
                position: absolute;
                left: -16px;
                top: -14px;
                transform-style: preserve-3d;

                img {
                    width: 100%;
                    height: 100%;
                    // backface-visibility: hidden;
                    transform: rotateY(-180deg);
                }
            }

            /deep/ p {
                font-size: 26px;
                color: #fff;
                line-height: 1.4;
                // padding-right: 50px;
                box-sizing: border-box;

                span {
                    color: #65d4ff;
                    max-width: 200px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    // display: block;
                }
            }
        }

        .popup-friend-list {
            width: 474px;
            height: 414px;
            background: url(~@/assets/img/pop_fri_list_bg.png) center/100% 100%
                no-repeat;
            margin: 19px auto;
            padding-bottom: 10px;
            box-sizing: border-box;
            &-head {
                display: flex;
                height: 60px;
                align-items: center;
                span {
                    // flex: 1;
                    font-size: 24px;
                    line-height: 1.1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: #1f3c46;
                    &:nth-child(1) {
                        width: 30%;
                    }
                    &:nth-child(2) {
                        width: 30%;
                    }
                    &:nth-child(3) {
                        width: 15%;
                    }
                    &:nth-child(4) {
                        width: 25%;
                    }
                }
            }

            &-body {
                width: 100%;
                height: 340px;
                overflow: hidden;

                /deep/ .empty_tips {
                    width: 100%;
                    // height: 80px;
                    line-height: 40px;
                    font-size: 24px;
                    text-align: center;
                    padding: 40px 30px 0;
                    box-sizing: border-box;

                    span {
                        color: #ee4949;
                    }
                }

                li {
                    display: flex;
                    height: 60px;
                    padding: 0 5px;
                    box-sizing: border-box;
                    &:nth-child(even) {
                        background-color: #f5fcfc;
                        background-clip: content-box;
                    }
                    // align-items: center;
                    span {
                        font-size: 22px;
                        line-height: 1.4;
                        display: flex;
                        // text-align: center;
                        align-items: center;
                        justify-content: center;
                        color: #454a4c;
                        &:nth-child(1) {
                            display: block;
                            width: 30%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            line-height: 60px;
                            text-align: center;
                            padding-left: 10px;
                            box-sizing: border-box;
                            text-decoration: underline;
                        }
                        &:nth-child(2) {
                            width: 30%;
                        }
                        &:nth-child(3) {
                            width: 15%;
                        }
                        &:nth-child(4) {
                            width: 25%;
                            background: url(~@/assets/img/battle_again.png)
                                center no-repeat;
                            background-size: 29px 29px;
                        }
                    }
                }
            }
        }
    }
}
</style>
